import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { Megaphone, X, MessageCircle } from "lucide-react";

const KEY = "ci_popup_seen";

export function AnnouncementPopup() {
  const nav = useNavigate();
  const { openWhatsApp } = useSettings();
  const [ann, setAnn] = useState(null);

  useEffect(() => {
    if (sessionStorage.getItem(KEY)) return;
    api.get("/announcements").then((r) => {
      const p = r.data.find((a) => a.popup);
      if (p) setAnn(p);
    }).catch(() => {});
  }, []);

  const close = () => { sessionStorage.setItem(KEY, "1"); setAnn(null); };
  if (!ann) return null;

  const tone = { maintenance: "text-red-300", new: "text-emerald-300", update: "text-cyan-300", info: "text-amber-300" }[ann.type] || "text-amber-300";
  const label = { maintenance: "Manutenção", new: "Novidade", update: "Atualização", info: "Aviso importante" }[ann.type] || "Aviso";

  return (
    <div className="fixed inset-0 z-[100] bg-black/75 backdrop-blur-sm flex items-center justify-center p-4" onClick={close} data-testid="announcement-popup">
      <div onClick={(e) => e.stopPropagation()}
        className="ci-card relative w-full max-w-md p-7 border-amber-400/30 ci-reveal" style={{ background: "linear-gradient(160deg,#131C2E,#1a1508)" }}>
        <button onClick={close} data-testid="announcement-popup-close" className="absolute top-3 right-3 p-2 rounded-lg bg-white/5 hover:bg-white/10"><X className="w-4 h-4" /></button>
        <div className="w-12 h-12 rounded-xl bg-amber-400/15 border border-amber-400/30 flex items-center justify-center mb-4">
          <Megaphone className="w-6 h-6 text-amber-300" />
        </div>
        <div className={`text-xs font-semibold uppercase tracking-widest mb-1 ${tone}`}>{label}</div>
        <h3 className="text-xl font-bold mb-2" data-testid="announcement-popup-title">{ann.title}</h3>
        <p className="text-sm text-gray-300 leading-relaxed">{ann.message}</p>
        <div className="flex flex-wrap gap-2 mt-6">
          <button onClick={close} data-testid="announcement-popup-ok" className="ci-btn-gold px-5 py-2.5 rounded-full font-semibold text-sm hover:brightness-105">Entendi</button>
          <button onClick={() => { close(); nav("/status"); }} data-testid="announcement-popup-status" className="px-5 py-2.5 rounded-full text-sm border border-white/15 hover:bg-white/5">Ver status</button>
          <button onClick={() => { openWhatsApp("popup"); close(); }} data-testid="announcement-popup-whatsapp" className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full text-sm text-emerald-300 hover:bg-emerald-500/10">
            <MessageCircle className="w-4 h-4" /> Suporte
          </button>
        </div>
      </div>
    </div>
  );
}
